module.exports = "<simple-notifications [options]=\"notifyOptions\"></simple-notifications>\n<app-loading-bar *ngIf=\"loading$ | async\"></app-loading-bar>\n\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main